module.exports = __webpack_public_path__ + "images/noReviewImage.fbab45da.svg";